import FIRsService from "../../services/firs.service";

const state = {
    FIRsList: [],
    countryList: [],
    NotamImportantListModule : [],
};
const mutations = {

    set_firs(state, payload) {
        state.FIRsList = payload;
    },

    clear_firs(state){
        state.FIRsList=[] ;
    },

    set_fir(state, payload) {
        state.FIRsList.unshift(payload);
    },

    set_fir_update(payload) {
        console.log(payload);
    },

    set_country(state, payload) {
        state.countryList = payload;
    },

    set_NotamImportantWordList(state,payload){
        state.NotamImportantListModule = payload;
    },

    clear_NotamImportantWordList(state){
        state.NotamImportantListModule = []
    }

};
const actions = {
    async GetFIRs({commit}) {
        await commit("clear_firs")
        const firs = await FIRsService.GetFIRsService();
        await commit("set_firs", firs);
        return firs;
    },

    async AddFir({commit}, payload) {
        const fir = await FIRsService.AddFIRService(payload);
        //console.log(fir);
        await commit("set_fir", fir);
        return fir;
    },

    async UpdateFir({commit,dispatch}, payload) {
        const updatefir = await FIRsService.UpdateFIRService(payload);
        await commit("set_fir_update" , updatefir);
        await dispatch("GetFIRs");
        return updatefir;
    },

    async DeleteFir({dispatch},payload)
    {
        const updatefir = await FIRsService.DeleteFIRService(payload);
        await dispatch("GetFIRs");
        return updatefir;
    },

    async GetCountry({commit})
    {
        const country = await FIRsService.GetCountry();
        await commit("set_country", country);
        return country;

    },

    async GetNotamImportantList({commit}) {

        await commit("clear_NotamImportantWordList")
        const resplist = await FIRsService.getNotamImportantWordList_service();
        await commit("set_NotamImportantWordList", resplist)

    },

    async AddNotamImportantWord({dispatch}, payload)
    {
        const resp = await FIRsService.addNotamImportantWordList_service(payload);
        await dispatch("GetNotamImportantList");
        return resp;
    },

    async UpdateNotamImportantWord({dispatch}, payload) {
        const updatedNotamword = await FIRsService.editNotamImportantWordList_service(payload);
        await dispatch("GetNotamImportantList");
        return updatedNotamword;
    },

    async DeleteNotamImportantWord({dispatch},payload){
        const DeleteNotamword = await FIRsService.deleteNotamImportantWordList_service(payload);
        await dispatch("GetNotamImportantList");
        return DeleteNotamword;
    },


};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
